import { type PropsWithChildren, type ReactNode } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { type PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

export interface PaymentPlanReviewLink extends PressableAnalyticsProps {
  label: string;
  onPress: () => void;
}

interface PaymentPlanReviewLayoutProps extends PropsWithChildren {
  footer: ReactNode;
}

const PaymentPlanReviewLayout = ({
  children,
  footer,
}: PaymentPlanReviewLayoutProps) => {
  const { bottom } = useSafeAreaInsets();
  const footerBottomPadding = bottom + theme.spacing.m;

  return (
    <View style={styles.container}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollViewContent}
      >
        {children}
      </ScrollView>
      <View style={[styles.footer, { paddingBottom: footerBottomPadding }]}>
        {footer}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
  footer: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
    gap: theme.spacing.m,
    borderTopWidth: 1,
    borderTopColor: theme.color.border.primary,
  },
  scrollView: { flex: 1 },
  scrollViewContent: { gap: theme.spacing.s },
});

export default PaymentPlanReviewLayout;
